import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SignupPage } from '../../pages/signup/signup.page';
import { Router } from '@angular/router';

@Component({
  selector: 'app-just-making-sure-modal',
  templateUrl: './just-making-sure-modal.page.html',
  styleUrls: ['./just-making-sure-modal.page.scss'],
})
export class JustMakingSureModalPage implements OnInit {
  
  @Input() contactMethod: string;
  @Input() contactValue: string;
  
  decryptedData: any; // Store the full decrypted object

  constructor(private modalController: ModalController, private router: Router) { }

  ngOnInit() {
    // Get the entire decrypted object from localStorage
    const storedData = localStorage.getItem('deeplinkDecryptedData');
    if (storedData) {
      this.decryptedData = JSON.parse(storedData);
      // Use stored values if props not passed
      if (!this.contactMethod) {
        this.contactMethod = this.decryptedData.method;
      }
      if (!this.contactValue) {
        this.contactValue = this.decryptedData.contactValue;
      }
    }
  }

  async yes() {
    await this.modalController.dismiss('no');

    // Get the full decrypted object from storage
    const storedData = localStorage.getItem('deeplinkDecryptedData');
    const decryptedData = storedData ? JSON.parse(storedData) : null;

    const contactMethod = this.contactMethod || decryptedData?.method;
    const contactValue = this.contactValue || decryptedData?.contactValue;

    // Store for SignupPage
    if (contactMethod?.toLowerCase() === 'email' && contactValue) {
      localStorage.setItem('emailFromLogin', contactValue);
    }
    if (contactMethod?.toLowerCase() === 'mobile' && contactValue) {
      localStorage.setItem('mobileFromLogin', contactValue);
    }

    const modal = await this.modalController.create({
      component: SignupPage,
      cssClass: 'modal_login',
      backdropDismiss: false,
      componentProps: {
        from: 'login',
        contactMethod: contactMethod,
        contactValue: contactValue,
        username: contactMethod?.toLowerCase() === 'email' ? contactValue : '',
        decryptedData: decryptedData // Pass the whole object
      }
    });
    await modal.present();
  }

  no() {
    // First, get the contact method and value (before removing from localStorage)
    const storedData = localStorage.getItem('deeplinkDecryptedData');
    const decryptedData = storedData ? JSON.parse(storedData) : null;

    const contactMethod = this.contactMethod || decryptedData?.method;
    const contactValue = this.contactValue || decryptedData?.contactValue;

    // Dismiss modal first
    this.modalController.dismiss('yes');

    // Navigate to signup-punchlist-email with query params for auto-connect
    setTimeout(() => {
      this.router.navigate(['/signup-punchlist-email'], {
        queryParams: {
          autoConnect: 'true',
          contactMethod: contactMethod,
          contactValue: contactValue
        }
      });
    }, 300);

    // Clean up stored data after navigation (optional - you may want to keep it until signup is complete)
    // localStorage.removeItem('deeplinkDecryptedData');
    // localStorage.removeItem('emailFromLogin');
    // localStorage.removeItem('mobileFromLogin');
  }

  goBack() {
    // Clean up stored data when modal is dismissed
    localStorage.removeItem('deeplinkDecryptedData');
    localStorage.removeItem('emailFromLogin');
    localStorage.removeItem('mobileFromLogin');
    this.modalController.dismiss();
  }

}

